import {gql} from 'apollo-boost'

export const GET_USER = gql`
  query getUser($id: ID!) {
    getUser(
      id: $id
    ) {
      id
      photo
      username
      prefix{
        id
        nameTh
      }
      name
      surname
      email
      status
      oneTimePassword
      oneTimePasswordReset
      type
      saleCode
      role{
        id
        nameTh
        nameEn
        status
      }
    }
  }
`

export const GET_USERS = gql`
  query getUsers {
    getUsers{
      id
      photo
      username
      prefix{
        id
        nameTh
      }
      name
      surname
      email
      status
      oneTimePassword
      oneTimePasswordReset
      type
      saleCode
      role{
        id
        nameTh
        nameEn
        status
      }
    }
  }
`

export const GET_USER_OPTIONS = gql`
  query getUsers {
    getUsers{
      id
      photo
      username
      prefix{
        id
        nameTh
      }
      name
      surname
      email
      status
    }
  }
`

export const CREATE_USER = gql`
  mutation createUser($payload: UserInput) {
    createUser(
      payload: $payload
    ){
      id
      photo
      username
      prefix{
        id
        nameTh
      }
      name
      surname
      email
      status
      oneTimePassword
      oneTimePasswordReset
      type
      saleCode
      role{
        id
        nameTh
        nameEn
        status
      }
    }
  }
`

export const UPDATE_USER = gql`
  mutation updateUser($id: ID!, $payload: UserInput!) {
    updateUser(
      id: $id,
      payload: $payload
    ) {
      id
      photo
      username
      prefix{
        id
        nameTh
      }
      name
      surname
      email
      status
      oneTimePassword
      oneTimePasswordReset
      type
      saleCode
      role{
        id
        nameTh
        nameEn
        status
      }
    }
  }
`

export const RESET_PASSWORD = gql`
  mutation resetPassword($id: String!) {
    resetPassword(
      id: $id
    ) {
      id
      photo
      username
      prefix{
        id
        nameTh
      }
      name
      surname
      email
      status
      oneTimePassword
      oneTimePasswordReset
      type
      saleCode
      role{
        id
        nameTh
        nameEn
        status
      }
    }
  }
`

export const CREATE_PASSWORD_DUMMY_STUDENT_APP = gql`
  mutation createPasswordDummyStudentApp($id: String!) {
    createPasswordDummyStudentApp(
      id: $id
    ) {
      result
      msg
    }
  }
`

export const DELETE_USER = gql`
  mutation deleteUser($id: ID!) {
    deleteUser(
      id: $id
    ) {
      id
    }
  }
`

export const GET_STUDENT = gql`
  query getStudent($id: ID!) {
    getStudent(
      id: $id
    ) {
      id
      photo
      username
      prefix{
        id
        nameTh
      }
      name
      surname
      email
      status
      oneTimePassword
      oneTimePasswordReset
      type
      saleCode
      role{
        id
        nameTh
        nameEn
        status
      }
    }
  }
`

export const GET_STUDENTS = gql`
  query getStudents {
    getStudents{
      id
      photo
      username
      prefix{
        id
        nameTh
      }
      name
      surname
      email
      status
      oneTimePassword
      oneTimePasswordReset
      type
      saleCode
      role{
        id
        nameTh
        nameEn
        status
      }
    }
  }
`
